import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./utilityIcons.html";
import { throwDevelopmentOrLog } from '~/modules/utilities/errorUtilities';
import agentAstroTemplate from './agentAstroIcon.html';

// TODO this should be deleted when we update the lightning design system to the latest version which includes the new utility_astro_agent icon
const ICON_TEMPLATES = {
  astro_agent: agentAstroTemplate
};
class UtilityIcons extends LightningElement {
  constructor(...args) {
    super(...args);
    this.type = void 0;
    this.alternativeText = '';
    this.width = '24px';
    this.height = '24px';
  }
  render() {
    const template = ICON_TEMPLATES[this.type];
    if (!template) {
      throwDevelopmentOrLog(new Error(`Failed to find utility icon of type: ${this.type}`));
    }
    return template;
  }
  /*LWC compiler v7.1.3*/
}
UtilityIcons.delegatesFocus = true;
_registerDecorators(UtilityIcons, {
  publicProps: {
    type: {
      config: 0
    },
    alternativeText: {
      config: 0
    },
    width: {
      config: 0
    },
    height: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(UtilityIcons, {
  tmpl: _tmpl,
  sel: "appx-utility-icons",
  apiVersion: 62
});
export default __lwc_component_class_internal;